import { MarketingPage } from '../../components/landing/MarketingPage';
import { FounderLetter } from './FounderLetter';

export function About() {
  return (
    <MarketingPage>
      <FounderLetter />
    </MarketingPage>
  );
}
